import { _ as __assign } from '../../chunks/bundle-C7jYHvwG.js';
import React__default from 'react';
import { S as SuggestedMentionListView } from '../../chunks/bundle-BL_0pgq0.js';
import '../../chunks/bundle-DImSV9VW.js';
import '../../chunks/bundle-pOZPN8hk.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-DUTyBaXr.js';
import '../../chunks/bundle-CbEyAimK.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-BR3O1lZq.js';
import '../../chunks/bundle-CIN9yQRB.js';
import '../../chunks/bundle-4W3uBGU3.js';
import '../../useSendbirdStateContext.js';
import '../../withSendbird.js';
import '../../chunks/bundle-Dpdq7qeD.js';
import '../../chunks/bundle-C9dF4QVS.js';

var SuggestedMentionList = function (props) {
    return (React__default.createElement(SuggestedMentionListView, __assign({}, props)));
};

export { SuggestedMentionList, SuggestedMentionList as default };
//# sourceMappingURL=SuggestedMentionList.js.map
